import { ChangeEvent } from "react";
// import { useNavigate } from "react-router-dom";
// import { AutoComplete } from "primereact/autocomplete";

// import { requests } from "../../../../services/http-common";
// import { IJobDetail, IJobSchedule } from "../../../../models/JobZone";

import classes from "./ScheduleSearch.module.scss";
import { InputText } from "primereact/inputtext";

interface ScheduleSearchProps {
  value: string | undefined;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const ScheduleSearch = ({ value, onChange }: ScheduleSearchProps) => {
  // const [inputValue, setInputValue] = useState("");
  // const [suggestions, setSuggestions] = useState<IJobSchedule[]>([]);

  // const navigate = useNavigate();

  // const itemTemplate = (options: { jobDetail: IJobDetail }) => {
  //   return (
  //     <div className={classes.searchItem}>
  //       <div className={classes.info}>
  //         <p>{options.jobDetail.name}</p>
  //       </div>
  //     </div>
  //   );
  // };

  // const search = (e: { query: string }) => {
  //   requests.get(`/job/jobSchedule?filter=${e.query}`).then((res: any) => {
  //     setSuggestions(res.result);
  //   });
  // };

  return (
    <div className={classes.searchScheduleContainer}>
      <InputText placeholder="Search" onChange={onChange} value={value} />
      {/* <AutoComplete
        appendTo={null}
        completeMethod={search}
        onChange={(e) => {
          setInputValue(e.value);
        }}
        onSelect={(e) => {
          navigate(`/scheduling-execution/schedule/${e.value.id}/view`);
        }}
        field="name"
        placeholder="Search "
        suggestions={suggestions}
        value={inputValue}
        delay={500}
        itemTemplate={itemTemplate}
      /> */}
    </div>
  );
};
